import request from "graphql-request";
import BASEURL from "../Utils/Baseurl";
import {
  createOnsiteEmployeeDetails,
  updateOnsiteEmployeeDetails,
} from "./onsitequery";

export const addOnsiteService = async (
  employeeValues,
  travelValues,
  userId
) => {
  const modifiedArray = travelValues.map((v, i) => ({
    user: userId,
    documentSubmissionMail: v?.documentSubmissionMail || null,
    documentComments: v?.documentComments,
    medicalTestApplied: v?.medicalTestApplied || null,

    medicalTestAppliedComments: v?.medicalTestAppliedComments,

    medicalTestReport: v?.medicalTestReport || null,

    medicalTestReportComments: v?.medicalTestReportComments,

    biometric: v?.biometric || null,

    biometricComments: v?.biometricComments,

    documentSubmission: v?.documentSubmission || null,

    documentSubmissionComments: v?.documentSubmissionComments,

    documentReturned: v?.documentReturned || null,

    documentReturnedComments: v?.documentReturnedComments,

    visaStamped: v?.visaStamped || null,

    visaStampedComments: v?.visaStampedComments,

    reachedOnSite: v?.reachedOnSite || null,

    reachedOnSiteComments: v?.reachedOnSiteComments,
    startFromIndia: v?.startFromIndia || null,
    startFromIndiaComments: v?.startFromIndiaComments,
    visaExpiryDays: v?.visaExpiryDays,

    visaExpiryDate: v?.visaExpiryDate || null,

    visaExpiryComments: v?.visaExpiryComments,

    startFromOnsite: v?.startFromOnsite || null,

    startFromOnsiteComments: v?.startFromOnsiteComments,

    returnedToCountry: v?.returnedToCountry || null,

    returnedToCountryComments: v?.returnedToCountryComments,
  }));

  let status = false;
  let message = "";

  try {
    const res = await request(BASEURL, createOnsiteEmployeeDetails, {
      input: {
        ...employeeValues,
        user: userId,
        onsiteStatus: true,
        documents: modifiedArray,
      },
    });
    if (res.errors) {
      message = "Something went wrong.";

      return { status: false, message };
    }
    status = true;
    message = "Submit Your Details";
  } catch (error) {
    message = "Network error occurred.";
    status = false;
  }

  return { status, message };
};

export const editOnsiteService = async (values, travel) => {
  let status = false;
  let message = "";
  try {
    const res = await request(BASEURL, updateOnsiteEmployeeDetails, {
      input: {
        ...values,
        onsiteStatus: true,
        documents: travel,
      },
    });
    if (res.errors) {
      message = "Something went wrong.";

      return { status: false, message };
    }
    status = true;
    message = "Update Your Details";
  } catch (error) {
    message = "Network error occurred.";
    status = false;
  }
  return { status, message };
};
